import React, { FC, memo } from 'react'
import SvgIcon from './SvgIcon'

type Props = {
  size?: number
  [key: string]: unknown
}

type CreateSvgIcon = (
  path: React.ReactNode,
  displayName?: string,
  size?: number,
  viewBox?: string,
  hasToRotateOnRtl?: boolean
) => FC<Props>

const createSvgIcon: CreateSvgIcon = (
  path,
  displayName = '',
  size = 24,
  viewBox,
  hasToRotateOnRtl = false
) => {
  const defaultViewBox = `0 0 ${size} ${size}`
  const Component: FC<Props> = memo((props: Props) => {
    return (
      <SvgIcon
        data-testid={`${displayName}Icon`}
        size={size}
        viewBox={viewBox ?? defaultViewBox}
        data-rotateonrtl={hasToRotateOnRtl}
        {...props}
      >
        {path}
      </SvgIcon>
    )
  })

  if (process.env.NODE_ENV !== 'production' && displayName) {
    Component.displayName = `${displayName}Icon`
  }

  return Component
}

export default createSvgIcon
